import clsx from "clsx";
import * as React from "react";

import * as PropTypes from "../prop-types";
import { PropsType } from "../PropsType";
import { spsGlobalPropTypes } from "../util";

import {
    SpsButton
} from "../button/SpsButton";

export const propTypes = {
    ...spsGlobalPropTypes,
    clearSelected: PropTypes.func.isRequired,
    itemsSelected: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

export type SpsListActionBarProps = PropsType<typeof propTypes> & React.HTMLAttributes<HTMLDivElement>;

export function SpsListActionBar(props: SpsListActionBarProps) {
    const {
        itemsSelected,
        clearSelected,
        children,
        className,
        "data-testid": testId,
        unsafelyReplaceClassName,
        ...rest
    } = props;

    const handleClearClick = () => {
        if (typeof clearSelected === "function")
            clearSelected()
    }

    const classes = clsx(
        unsafelyReplaceClassName || "sps-list-action-bar-container",
        "z-stratum-bar",
        className,
    );

    return (
        (!!itemsSelected && <div className={classes} {...rest} data-testid={testId}>
            <div className="sps-list-action-bar">
                <div className="sps-list-action-bar__details">
                    <span className="sps-badge sps-badge--info" data-testid={`${testId}__badge`}>{itemsSelected}</span>
                    Items Selected
                    </div>
                <div className="sps-list-action-bar__actions">{children}</div>
                <div className="sps-list-action-bar__clear">
                    <SpsButton
                        kind="link"
                        icon="x"
                        onClick={handleClearClick}
                        data-testid={`${testId}__clear-button`}
                    >
                        Clear Selected
                        </SpsButton>
                </div>
            </div>
        </div>)
    );
}

Object.assign(SpsListActionBar, {
    propTypes,
    displayName: "SpsListActionBar"
});
